import Vue from 'vue'
import vueAwesomeCountdown from 'vue-awesome-countdown'
Vue.use(vueAwesomeCountdown, 'countdown')



// WEBPACK FOOTER //
// ./src/bibliotecas/vue/vueawesomecountdown.js